export const FREE_1_PROJECT_PLAN_SLUG = 'free-6-team-members';
export const FREE_2_PROJECTS_PLAN_SLUG = 'free-2-projects';
export const PRO_PLAN_SLUG = 'pro';
export const COMPANY_3_PERSON_PLAN_SLUG = 'company-3-person';
export const COMPANY_6_PERSON_PLAN_SLUG = 'company-6-person';

export const MARVEL_PLANS = [
  FREE_1_PROJECT_PLAN_SLUG,
  PRO_PLAN_SLUG,
  COMPANY_3_PERSON_PLAN_SLUG,
];



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/constants/plans/plans.js